import config from "../../config.json";

const BASE_AUTH_API = config.BASE_AUTH_API;
const INTEGRATION_PORTAL_ENDPOINT = "integration-portal";

const apiRequest = async ({
  token,
  endpoint,
  method = "GET",
  body,
}) => {
  try {
    const response = await fetch(
      `${BASE_AUTH_API}${INTEGRATION_PORTAL_ENDPOINT}${endpoint}`,
      {
        method,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        ...(body !== undefined && {
          body: JSON.stringify(body),
        }),
      },
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || data.error || "Request failed");
    }

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOverviewAPI = async (token) =>
  apiRequest({
    token,
    endpoint: "/overview",
  });

export const updateProfileAPI = async (token, storeId, body) =>
  apiRequest({
    token,
    endpoint: `/restaurants/${storeId}/profile`,
    method: "PATCH",
    body,
  });

export const upsertAdminAppAPI = async (
  token,
  storeId,
  appId,
  body,
) =>
  apiRequest({
    token,
    endpoint: `/restaurants/${storeId}/admin-apps/${appId}`,
    method: "PUT",
    body,
  });

export const updateBranchAPI = async (
  token,
  storeId,
  branchId,
  body,
) =>
  apiRequest({
    token,
    endpoint: `/restaurants/${storeId}/branches/${branchId}`,
    method: "PATCH",
    body,
  });

export const upsertBranchAppAPI = async (
  token,
  storeId,
  branchId,
  appId,
  body,
) =>
  apiRequest({
    token,
    endpoint: `/restaurants/${storeId}/branches/${branchId}/apps/${appId}`,
    method: "PUT",
    body,
  });

export const createRequestAPI = async (token, body) =>
  apiRequest({
    token,
    endpoint: "/requests",
    method: "POST",
    body,
  });

export const transitionRequestAPI = async (
  token,
  requestId,
  action,
  comment = "",
) =>
  apiRequest({
    token,
    endpoint: `/requests/${requestId}/transition`,
    method: "PATCH",
    body: {
      action,
      comment,
    },
  });

export const addCommentAPI = async (token, requestId, text) =>
  apiRequest({
    token,
    endpoint: `/requests/${requestId}/comments`,
    method: "POST",
    body: {
      text,
    },
  });

export const deleteRequestAPI = async (token, requestId) =>
  apiRequest({
    token,
    endpoint: `/requests/${requestId}`,
    method: "DELETE",
  });

export const restoreRequestAPI = async (token, requestId) =>
  apiRequest({
    token,
    endpoint: `/requests/${requestId}/restore`,
    method: "PATCH",
  });
